export const GAME_TITLE = "MNK Valentine's Day Puzzle";
export const MAX_MISTAKES = 4;
